module.exports = __webpack_public_path__ + "img/card-statistics-yuri.cadd24cb.webp";